import { Checkbox, FormLabel, Textinput } from "shared";
import {
    ITemplateComponent,
    ITemplateInputComponent
} from "entities/template";
import React from "react";
import { useComponentsTranslations } from "../../../../lib/i18n";
import { VisibilityField } from "../../form_fields/visibility_field/visibility_field";
import { LabelField } from "../../form_fields/label_field/label_field";
import { TooltipField } from "../../form_fields/tooltip_field/tooltip_field";
import { useComponentValidateFunction } from "../../../../lib/hooks/useComponentValidateFunction";
import styles from "./component_form_input.module.scss";

interface IComponentFormInputProps {
    component: ITemplateInputComponent;
    enLanguageEnabled: boolean;
    componentList: ITemplateComponent[];
    triggerValidate: number;
    onChange: (component: ITemplateComponent) => void;
}

export const ComponentFormInput: React.FC<IComponentFormInputProps> = React.memo(({
                                                                                      component,
                                                                                      enLanguageEnabled,
                                                                                      componentList,
                                                                                      triggerValidate,
                                                                                      onChange
                                                                                  }) => {
    const t = useComponentsTranslations();
    const { validateTag } = useComponentValidateFunction();

    const onFieldChange = (value: Partial<ITemplateInputComponent>) => {
        onChange({
            ...component,
            ...value
        })
    }

    return <div className={styles.container}>
        <LabelField component={component}
                    enLanguageEnabled={enLanguageEnabled}
                    title={t("formLabel")}
                    name="label-dynamic-input"
                    onChange={onFieldChange}/>
        <FormLabel title={t("formTag")} required={true}>
            <Textinput size="m"
                       id="component_field_tag"
                       value={component.name ? component.name : ""}
                       triggerValidate={triggerValidate}
                       validate={true}
                       validateFunc={validateTag}
                       onChange={(e) => onFieldChange({ name: e.target.value })}
                       view="outline"/>
        </FormLabel>
        <VisibilityField
            component={component}
            componentList={componentList}
            onChange={onFieldChange}/>
        <TooltipField
            component={component}
            enLanguageEnabled={enLanguageEnabled}
            onChange={onFieldChange}
        />
        <div className={styles.checkboxGroup}>
            <Checkbox
                id="component_field_required"
                label={t("requiredField")}
                size="m"
                onChange={() => onFieldChange({ required: typeof component.required === "boolean" ? !component.required : false })}
                checked={typeof component.required === "boolean" ? component.required : true}
            />
            <Checkbox
                id="component_field_row_group"
                label={t("rowGroup")}
                size="m"
                onChange={() => onFieldChange({ isRowGroup: !component.isRowGroup })}
                checked={component.isRowGroup}
            />
        </div>
        <Checkbox
            id="component_field_number_field"
            label={t("numberField")}
            size="m"
            onChange={() => onFieldChange({ isNumber: !component.isNumber })}
            checked={component.isNumber}
        />
        {component.isNumber && <div className={styles.textInputGroup}>
            <FormLabel title={t("minimumValue")} className={styles.groupedInput}>
                <Textinput size="m"
                           id="component_field_minimum_value"
                           type="number"
                           value={component.minNumber ? component.minNumber : ""}
                           onChange={(e) => onFieldChange({ minNumber: e.target.value })}
                           view="outline"/>
            </FormLabel>
            <FormLabel title={t("maximumValue")} className={styles.groupedInput}>
                <Textinput size="m"
                           id="component_field_maximum_value"
                           type="number"
                           value={component.maxNumber ? component.maxNumber : ""}
                           onChange={(e) => onFieldChange({ maxNumber: e.target.value })}
                           view="outline"/>
            </FormLabel>
        </div>}
        <div className={styles.textInputGroup}>
            <FormLabel title={t("minimumStringLength")} className={styles.groupedInput}>
                <Textinput size="m"
                           id="component_field_minimum_string_length"
                           type="number"
                           value={component.minStringLength ? component.minStringLength : ""}
                           onChange={(e) => onFieldChange({ minStringLength: e.target.value })}
                           view="outline"/>
            </FormLabel>
            <FormLabel title={t("maximumStringLength")} className={styles.groupedInput}>
                <Textinput size="m"
                           id="component_field_maximum_string_length"
                           type="number"
                           value={component.maxStringLength ? component.maxStringLength : ""}
                           onChange={(e) => onFieldChange({ maxStringLength: e.target.value })}
                           view="outline"/>
            </FormLabel>
        </div>
    </div>;
});

